import { Component } from '@angular/core';
declare var bootstrap: any; // To access Bootstrap modals
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { UiformBaseComponent } from '../uiform-base/uiform-base.component';
import * as QRCode from 'qrcode';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Editor, toHTML, Toolbar } from 'ngx-editor';
import { HttpResponse } from '@angular/common/http';

interface RowData {
  id: number;
  selected?: boolean;
  editing?: boolean;
  editingField?: string;
  _originalValue?: any;
  [key: string]: any;
}
@Component({
  selector: 'app-uiform-list',
  templateUrl: './uiform-list.component.html',
  styleUrls: ['./uiform-list.component.scss'],
})
export class UiformListComponent extends UiformBaseComponent {
  public usecaseSchema: any = {};
  public entryform: any = {
    data: { id: 0 }, //form data
  };
  toggleTag(index: number, event: any): void {
    // if (!event.target.checked) {
    //   this.removeTag(index);
    // }
  }
  sortedField: string | null = null;
  sortOrder: 'ASC' | 'DESC' | null = null;
  formfileds: any;
  formId: any = 0;
  pdfEmail: any = false;
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {
    super(locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('appId'))
      _self.appId = Number(route.snapshot.paramMap.get('appId'));

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));

    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));

    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  override ngOnInit() {
    let _self = this;
    if (_self.uiformId)
      this.get(_self.uiformId, function () {
        _self.formfileds = _self.form.data?.fields;
        _self.usecaseId = _self.form.data.userstoryId;
        _self.formId = _self.form.data.id;
        _self.getUsecaseSchema(true, () => {
          _self.enabletag = _self.usecase?.tagenable || 0;
          _self.selectedTags = _self.textData?.split(',') || [];
        });
      });
  }

  /**
   * get usecase records list
   */
  override search(callback?: any): void {
    let _self = this;
    _self.getUiformDataList();
  }

  sortTable(field: string): void {
    let _self = this;
    if (this.sortedField === field) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortedField = field;
      this.sortOrder = 'ASC';
    }
    _self.form.searchParams['orderBy'] = this.sortedField;
    _self.form.searchParams['asc'] = this.sortOrder;
    _self.getUiformDataList();
  }

  override processData() {
    this.filteredData = [...this.usecaseData];
  }

  public getUiformDataList() {
    let _self = this;
    let list_key = 'uiform_listdata';
    if (list_key in localStorage) {
      const jsonData = localStorage.getItem(list_key);
      if (jsonData) {
        _self.usecaseData = JSON.parse(jsonData);
        _self.filteredData = [..._self.usecaseData];
        localStorage.removeItem(list_key);
        return;
      }
    }
    this.getUsecaseDataList();
  }

  resetSearch() {
    var _self = this;
    _self.searchValues = {};
    _self.form.pageNo = 0;
    _self.getUsecaseDataList();
    _self.form.searchParams = {};
  }

  /**
   * Filer list by usecase name
   */
  public searchItem: string = '';

  reSearch() {
    var _self = this;
    _self.form.pageNo = 0;
    _self.getUsecaseDataList();
  }

  /**
   *
   * @returns Filter useacases
   */
  public filterData(): any {
    let _self = this;
    return this.usecaseData.filter((item) =>
      // Check if any value in the object matches the search term
      Object.values(item).some((value: any) =>
        value.toString().toLowerCase().includes(_self.searchItem.toLowerCase()),
      ),
    );
  }

  filteredData: any[] = [];

  filterTable() {
    this.filteredData = this.usecaseData.filter((item) => {
      return Object.keys(this.searchValues).every((key) => {
        const searchValue = this.searchValues[key]?.toLowerCase();
        const itemValue = (item[key] as string | number | undefined)
          ?.toString()
          .toLowerCase();
        return !searchValue || itemValue?.includes(searchValue);
      });
    });
  }

  onDelete(id: any) {
    this.deleteUseCaseData(id, () => {
      this.getUsecaseDataList();
    });
  }

  onNew() {}

  onEdit(id: any) {
    this.forward('uiform/' + this.uiformId + '/' + id);
  }

  /**
   * Export data
   */
  public exportData() {
    let _self = this;
    let url = _self.urlRewrite(_self.apiurl + '/export');
    //let url = _self.urlRewrite(_self.apiurl + '/export');
    let searchData = _self.getSearchCriteria();
    // searchData['pageNo'] = _self.form.pageNo;
    _self.locator.http
      .getClient()
      .post(url, searchData, { responseType: 'blob' })
      .subscribe(
        (data: any) => {
          _self.downloadDataAsFile(data, 'export.csv');
        },
        (data: any) => {
          console.error(data);
        },
      );
  }

  public exportPDFDataEmail() {
    const url = this.urlRewrite(this.apiurl + '/pdflist');
    const payload = this.getSearchCriteria();

    payload['totalCount'] = this.formListRecord;

    this.locator.http
      .getClient()
      .post(url, payload, {
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          const contentType = response.headers.get('content-type');

          //  PDF response
          if (contentType && contentType.includes('application/pdf')) {
            const blob = new Blob([response.body!], {
              type: 'application/pdf',
            });
            const downloadUrl = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = 'NcsIndore_Report.pdf';
            a.click();

            window.URL.revokeObjectURL(downloadUrl);
            return;
          }

          // JSON response (email flow)
          const reader = new FileReader();
          reader.onload = () => {
            const json = JSON.parse(reader.result as string);
            this.form['message'] = json.message;
            this.form['error'] = !json.success;
          };
          reader.readAsText(response.body!);
        },

        error: (error: any) => {
          console.error('PDF Export Error:', error);
          this.form['message'] = 'Server error, please try again.';
          this.form['error'] = true;
        },
      });
  }

  /**
   * Downalod data as file
   * @param data
   * @param fileName
   */
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: data.type });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }

  public showErrorModal: boolean = false;

  uploadResult = {
    uploadId: null as number | null,
    totalRows: 0,
    successRows: 0,
    errorRows: 0,
  };

  // Replace your existing onCsvFileUpload method with this updated version
  public onCsvFileUpload(event: any) {
    const fileObj = event.target.files[0];
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';

    let url =
      _self.locator.config.get('endpoint.userstory') +
      '/importCSV/' +
      _self.usecaseId;
    var param = {
      id: this.form.data.id,
    };

    this.locator.http.postMutipart(
      url,
      param,
      fileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          return;
        }

        _self.form.error = !res.success;

        if (res.success) {
          _self.form.message = 'File uploaded successfully';

          // Populate upload result
          _self.uploadResult = {
            uploadId: res.result.uploadId || null,
            totalRows: res.result.totalRows || 0,
            successRows: res.result.successfulUploads || 0,
            errorRows: res.result.errorRows || 0,
          };

          // Show the summary modal
          const summaryModal = new bootstrap.Modal(
            document.getElementById('uploadSummaryModal'),
          );
          summaryModal.show();

          // Refresh the list
          _self.search();
        } else {
          alert(res.message);
        }
      },
    );
  }

  /**
   * Export Sample data in CSV
   */
  public exportSampleData() {
    let _self = this;
    let url = _self.urlRewrite(_self.apiurl + '/exportSampleCSV');
    _self.locator.http
      .getClient()
      .post(url, {}, { responseType: 'blob' })
      .subscribe(
        (data: any) => {
          _self.downloadDataAsFile(data, 'export.csv');
        },
        (data: any) => {
          console.error(data);
        },
      );
  }

  /**
   *
   */
  getDescription(field: any) {
    if (field['description']) {
      return field['description'];
    }
    return field['label'];
  }

  viewMode: 'table' | 'card' = 'table';
  toggleView(mode: 'table' | 'card') {
    this.viewMode = mode;
  }

  inputValue: string = '';
  selectedTags: string[] = [];
  tagsList: string[] = [];
  filteredTagsList = [...this.tagsList];
  searchText = '';

  toggleTagSelection(tag: string, event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const checked = inputElement.checked;

    if (checked) {
      if (!this.selectedTags.includes(tag)) {
        this.selectedTags.push(tag);
      }
    } else {
      this.selectedTags = this.selectedTags.filter((t) => t !== tag);
    }
  }

  onTagCheckboxChange(tag: string, event: Event): void {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      if (!this.selectedTags.includes(tag)) {
        this.selectedTags.push(tag);
      }
    } else {
      this.selectedTags = this.selectedTags.filter((t) => t !== tag);
    }

    // ✅ Build full sanitized payload instead of just { tag, id }
    const fullPayload = this.buildSanitizedPayload(this.recordData);
    fullPayload['tag'] = this.selectedTags.join(', ');

    const url = this.urlRewrite(
      this.getAPIBaseUrl(this.form.data.code + '/saveForm'),
    );

    this.locator.http.post(url, fullPayload, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      if (res.success) {
        this.textData = res.result.data.tag ?? '';

        this.tagListData = this.textData
          .split(',')
          .map((t: string) => t.trim())
          .filter((t: string) => t !== '');

        this.selectedTags = [...this.tagListData];

        // ✅ Reflect in table row
        if (this.recordData) {
          this.recordData['tag'] = this.textData;
        }

        // ✅ Reflect in entryform so uiform displays updated tag
        if (this.entryform && this.entryform['data']) {
          this.entryform['data']['tag'] = this.textData;
        }

        // ✅ Sync filteredTagsList and tagsList with latest saved tags
        this.tagListData.forEach((t: string) => {
          if (!this.tagsList.includes(t)) {
            this.tagsList.push(t);
          }
        });
        this.filteredTagsList = [...this.tagsList];

        this.id = res.result['data']['id'];
        this.search(); // ✅ Refresh table
      } else {
        this.entryform['error'] = !res.success;
        this.entryform['message'] = res.message;
        this.entryform['inputerror'] = res.result?.inputerror;
        this.entryform['inputerrormsg'] = res.result?.inputerror
          ? Object.values(res.result.inputerror).join(', ')
          : '';
      }
    });
  }

  // Handle user input in the input field
  onUserInput(event: any) {
    this.searchText = event.target.value.toLowerCase().trim();
    // Show filtered only if input is not empty
    if (this.searchText) {
      this.filteredTagsList = this.tagsList.filter((tag) =>
        tag.toLowerCase().includes(this.searchText),
      );
    } else {
      this.filteredTagsList = [...this.tagsList]; // show all tags
    }
  }

  // Handle selection from the dropdown
  onSelectChange(event: any) {
    const selectedValue = event.target.value;
    if (selectedValue && !this.selectedTags.includes(selectedValue)) {
      this.selectedTags.push(selectedValue.trim());
    }
    this.updateInputField();
  }

  addTags() {
    const newTags = this.inputValue
      .split(',')
      .map((tag) => tag.trim())
      .filter((tag) => tag !== '');
    // Add new tags to the list if they don't exist
    newTags.forEach((tag) => {
      if (!this.tagsList.includes(tag)) {
        this.tagsList.push(tag);
      }
    });
    // Clear input field after adding
    this.inputValue = '';
    this.updateInputField();
  }

  updateInputField() {
    this.selectedTags = this.selectedTags.filter((item) => item !== undefined);
    const selectedTags = this.selectedTags.filter((tag) => tag.trim() !== '');
    this.inputValue = selectedTags.join(', ');
  }

  // Remove the last added tag
  public recordData: any = {};
  public addIndex: any;
  public recordCode: any;
  public textData: any;
  tagListData: any;

  allAttribute(recordData: any, addIndex: any) {
    this.getUsecaseDtaa1();

    console.log('allAttribute called');
    console.log('recordData:', recordData);
    console.log('addIndex:', addIndex);

    this.recordData = recordData;
    this.addIndex = addIndex;
    this.searchText = '';

    // Load master tags
    const tagItem = this.usecaseAttributes?.find(
      (item: any) => item.type === 'tag',
    );

    this.tagsList =
      tagItem?.values
        ?.map((t: string) => t.trim())
        .filter((t: string) => t !== '') || [];

    // Load selected tags of that row
    this.selectedTags = recordData.tag
      ? recordData.tag.split(',').map((t: string) => t.trim())
      : [];

    // Show all tags in modal
    this.filteredTagsList = Array.from(
      new Set([...this.tagsList, ...this.selectedTags]),
    );
    console.log('tagsList (available tags):', this.tagsList);
    console.log('selectedTags (pre-selected):', this.selectedTags);
    console.log('filteredTagsList (checkbox list):', this.filteredTagsList);

    this.inputValue = '';
  }

  // getUsecaseDtaa1() {
  //   let _self = this;
  //   let attrUrl =
  //     _self.locator.config.get('endpoint.userstory.attributes') +
  //     '/list/' +
  //     _self.usecaseId;
  //   if (
  //     _self.usecaseId != 0 &&
  //     _self.usecaseId != null &&
  //     _self.usecaseId != undefined
  //   ) {
  //     _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
  //       if (error) {
  //         alert('Server Error:' + error);
  //         return;
  //       }
  //       _self.usecaseAttributes = res.result.data;
  //       console.log('   _self.usecaseAttributes', _self.usecaseAttributes);
  //       const tagItem = _self.usecaseAttributes?.find(
  //         (item: any) => item.type === 'tag',
  //       );
  //       if (tagItem) {
  //         _self.tagsList = tagItem.values;
  //         console.log(' _self.tagsList', _self.tagsList);
  //       }
  //     });
  //   }
  // }

  getUsecaseDtaa1() {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      _self.usecaseId;
    if (
      _self.usecaseId != 0 &&
      _self.usecaseId != null &&
      _self.usecaseId != undefined
    ) {
      _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.usecaseAttributes = res.result.data;
        console.log('   _self.usecaseAttributes', _self.usecaseAttributes);
        const tagItem = _self.usecaseAttributes?.find(
          (item: any) => item.type === 'tag',
        );
        if (tagItem) {
          _self.tagsList = tagItem.values || [];
          console.log(' _self.tagsList', _self.tagsList);
        } else {
          // CREATE TAG ATTRIBUTE IF NOT EXIST
          console.log('Tag attribute not found. Creating...');

          const payload = {
            label: 'tag',
            type: 'tag',
            userstoryId: _self.usecaseId,
            values: [],
          };

          const saveUrl =
            _self.locator.config.get('endpoint.userstory.attributes') + '/save';

          _self.locator.http.post(
            saveUrl,
            payload,
            function (res2: any, err2: boolean) {
              if (err2) {
                console.error('Tag attribute creation failed');
                return;
              }

              console.log('Tag attribute created successfully');

              // Reload attributes after creating
              _self.getUsecaseDtaa1();
            },
          );
        }
      });
    }
  }

  getCleanTag(tag: string | null | undefined): string {
    if (typeof tag !== 'string' || tag.trim() === '') return 'Add Tags';
    return tag.replace(/^,\s*/, '');
  }

  code = '';
  // saveTags() {

  //   let _self = this;
  //   let entryTagsAdded = false;

  //   console.log("I am in save method .....");

  //   // Step 1: Save new tag values to usecaseAttributes
  //   _self.usecaseAttributes?.forEach((item: any) => {

  //     if (item.type === 'tag') {

  //       console.log("items types : ",item.type);

  //       let entryValues = _self.inputValue
  //         .split(',')
  //         .map((tag) => tag.trim())
  //         .filter((tag) => tag !== '' && !item.values.includes(tag));

  //         console.log("entry Values : ",entryValues);

  //       if (entryValues.length > 0) {
  //         entryTagsAdded = true;
  //         item.values.push(...entryValues);

  //         const payload = {
  //           label: item.label,
  //           type: item.type,
  //           userstoryId: _self.usecaseId,
  //           id: item.id,
  //           values: item.values,
  //         };

  //         console.log("payload : "+payload);

  //         let url =
  //           _self.locator.config.get('endpoint.userstory.attributes') + '/save';
  //         _self.locator.http.post(url, payload, (res: any, error: boolean) => {
  //           if (!error && res?.result?.data?.values) {
  //             _self.tagsList = Array.from(
  //               new Set(
  //                 res.result.data.values
  //                   .map((t: string) => t.trim())
  //                   .filter((t: string) => t !== ''),
  //               ),
  //             );
  //             _self.filteredTagsList = [..._self.tagsList];

  //             console.log("Filtered Tags List : ", _self.filteredTagsList);
  //           }
  //         });
  //       }
  //     }
  //   });

  //   // Step 2: Save tag value to form data
  //   let url = _self.urlRewrite(
  //     _self.getAPIBaseUrl(_self.form.data.code + '/saveForm'),
  //   );

  //   const textTags =
  //     _self.textData
  //       ?.split(',')
  //       .map((tag: string) => tag.trim())
  //       .filter((tag: string) => tag !== '') || [];

  //   console.log("text Tags : ", textTags);

  //   const selectedTags = _self.selectedTags
  //     .map((tag) => tag.trim())
  //     .filter((tag) => tag !== '');

  //   console.log("selectTags : ", selectedTags);

  //   const uniqueTags = Array.from(new Set([...textTags, ...selectedTags]));

  //   console.log("uniqueTags : " , uniqueTags);

  //   let data = uniqueTags.join(', ');

  //   console.log("data : ", data);

  //   const payload = {
  //     tag: data,
  //     id: _self.recordData?.id,
  //   };

  //   console.log("payload : "+ payload);

  //   _self.locator.http.post(url, payload, function (res: any, error: boolean) {
  //     if (error) {
  //       alert('Server Error:' + error);
  //       return;
  //     }
  //     _self.entryform['error'] = !res.success;
  //     _self.entryform['message'] = res.message;
  //     _self.entryform['inputerror'] = res.result?.inputerror;
  //     _self.entryform['inputerrormsg'] = res.result?.inputerror
  //       ? Object.values(res.result.inputerror).join(', ')
  //       : '';

  //     if (res.success) {
  //       _self.entryform['data']['id'] = res.result['data']['id'];
  //       _self.textData = res?.result?.data?.tag ?? '';

  //       _self.tagListData = _self.textData
  //         .split(',')
  //         .map((t: string) => t.trim())
  //         .filter((t: string) => t !== '');

  //       _self.selectedTags = [..._self.tagListData];

  //       // ✅ Always update tag list from selectedTags and tagsList
  //       const allTags = [..._self.selectedTags, ...(_self.tagsList || [])];
  //       _self.tagsList = Array.from(
  //         new Set(allTags.map((t) => t.trim()).filter((t) => t !== '')),
  //       );
  //       _self.filteredTagsList = [..._self.tagsList];

  //       _self.id = res.result['data']['id'];
  //       _self.search();
  //     }
  //   });

  //   _self.inputValue = '';
  // }

  saveTags() {
    if (!this.recordData) return;

    // Step 1: Add new tags to master list
    const newTags = this.inputValue
      .split(',')
      .map((t: string) => t.trim())
      .filter((t: string) => t !== '');

    console.log('newTags : ' + newTags);

    newTags.forEach((tag) => {
      if (!this.tagsList.includes(tag)) {
        this.tagsList.push(tag);
      }
      if (!this.selectedTags.includes(tag)) {
        this.selectedTags.push(tag);
      }
    });

    this.filteredTagsList = [...this.tagsList];

    console.log('Filter data : ' + this.filterAttributes);

    // Step 2: Update row tag locally
    const finalTags = Array.from(new Set(this.selectedTags));
    this.recordData.tag = finalTags.join(',');

    console.log('finalTags : ', finalTags);

    // Step 3: Save to backend
    const url = this.urlRewrite(
      this.getAPIBaseUrl(this.form.data.code + '/saveForm'),
    );

    // ✅ Use sanitized payload instead of raw recordData
    const payload = this.buildSanitizedPayload(this.recordData);

    console.log('Full Payload:', payload);

    this.locator.http.post(url, payload, (res: any, error: boolean) => {
      console.log('Backend response:', res, 'Error flag:', error);

      if (error || !res.success) {
        alert('Server Error');
        return;
      }

      // Update master tag attribute in backend
      const tagAttr = this.usecaseAttributes.find(
        (item: any) => item.type === 'tag',
      );

      if (tagAttr) {
        tagAttr.values = [...this.tagsList];

        const attrUrl =
          this.locator.config.get('endpoint.userstory.attributes') + '/save';

        this.locator.http.post(attrUrl, tagAttr, () => {});
      }

      console.log('Input value:', this.inputValue);
      console.log('selectedTags before save:', this.selectedTags);
      console.log('tagsList before save:', this.tagsList);

      this.search(); // refresh table
    });

    this.inputValue = '';
  }

  buildSanitizedPayload(sourceData: any): any {
    const filteredData = JSON.parse(JSON.stringify(sourceData));

    // Convert dateandtime fields
    const dateAndTime = this.usecaseAttributes.filter(
      (item: any) => item.type === 'dateandtime',
    );
    dateAndTime.forEach((item: any) => {
      if (filteredData[item.code]) {
        filteredData[item.code] = new Date(
          filteredData[item.code],
        ).toISOString();
      }
    });

    // Convert idate fields
    const idateData = this.usecaseAttributes.filter(
      (item: any) => item.type === 'idate',
    );
    idateData.forEach((item: any) => {
      if (filteredData[item.code]) {
        filteredData[item.code] = new Date(
          filteredData[item.code],
        ).toISOString();
      }
    });

    // Convert itime fields
    const timeAttributes = this.usecaseAttributes.filter(
      (item: any) => item.type === 'itime',
    );
    timeAttributes.forEach((item: any) => {
      if (filteredData[item.code]) {
        let value = filteredData[item.code];
        if (value && value.length === 5) {
          value = `1970-01-01T${value}:00`;
        }
        filteredData[item.code] = new Date(value).toISOString();
      }
    });

    // Trim text/textarea/password/email fields
    const textAttributes = this.usecaseAttributes.filter(
      (item: any) =>
        item.type === 'text' ||
        item.type === 'textarea' ||
        item.type === 'password' ||
        item.type === 'email',
    );
    textAttributes.forEach((attr: any) => {
      const key = attr.code;
      const value = filteredData[key];
      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed.length === 0) {
          delete filteredData[key];
        } else {
          filteredData[key] = trimmed;
        }
      }
    });

    // Remove expression fields
    const expressionAttributes = this.usecaseAttributes.filter(
      (item: any) => item.type === 'expression',
    );
    expressionAttributes.forEach((item: any) => {
      if (filteredData.hasOwnProperty(item.code)) {
        delete filteredData[item.code];
      }
    });

    return filteredData;
  }

  enabletag = 0;
  removeTag(index: number) {
    let _self = this;
    this.tagListData.splice(index, 1);
    this.textData = this.tagListData?.map((tag: any) => tag.trim()).join(', ');
    let url = _self.urlRewrite(
      _self.getAPIBaseUrl(_self.form.data.code + '/saveForm'),
    );
    const payload = {
      tag: this.textData,
      id: _self.recordData?.id,
    };
    _self.locator.http.post(url, payload, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.entryform['error'] = !res.success;
      _self.entryform['message'] = res.message;
      _self.entryform['inputerror'] = res.result?.inputerror;

      if (res.result?.inputerror) {
        _self.entryform['inputerrormsg'] = Object.values(
          res.result?.inputerror || {},
        ).join(', ');
      } else {
        _self.entryform['inputerrormsg'] = Object.values(
          res.result?.inputerror || {},
        ).join(', ');
      }
      if (res.success) {
        _self.entryform['data']['id'] = res.result['data']['id'];
        _self.textData = res?.result?.data?.tag;
        _self.tagListData = _self.textData?.split(',');
        _self.id = res.result['data']['id'];
        _self.search();
      }
    });

    _self.inputValue = '';
    _self.selectedTags = [];
  }

  resetTagInput(tagInput: any): void {
    tagInput.value = '';
    this.inputValue = '';
    this.filteredTagsList = [...new Set([...this.tagsList])];
  }

  getString1(value: string, type: string, timeType?: string): string {
    if (type === 'time' && value) {
      const [hours, minutes] = value.split(':').map(Number);
      if (timeType === '12') {
        const hour12 = hours % 12 || 12;
        const ampm = hours < 12 ? 'AM' : 'PM';
        return `${hour12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
      }
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}`;
    }
    return value; // for other types
  }

  getStringitime(value: string, type: string, timeType?: string): string {
    if (type === 'itime' && value) {
      let hours: number;
      let minutes: string;

      // Handle plain time format (23:12)
      if (/^\d{1,2}:\d{2}$/.test(value)) {
        const parts = value.split(':');
        hours = Number(parts[0]);
        minutes = parts[1];
      } else {
        const d = new Date(value); // ISO datetime
        hours = d.getHours();
        minutes = d.getMinutes().toString().padStart(2, '0');
      }

      if (timeType === '12') {
        const hour12 = hours % 12 || 12;
        const ampm = hours < 12 ? 'AM' : 'PM';
        return `${hour12}:${minutes} ${ampm}`;
      }
      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }
    return value;
  }

  masterSelected: boolean = false;
  selectAll() {
    this.filteredData.forEach((item: any) => {
      item.selected = this.masterSelected;
    });
  }

  checkIfAllSelected() {
    this.masterSelected = this.filteredData.every((item: any) => item.selected);
  }
  Deleteall() {
    const selectedItems = this.filteredData.filter((item) => item.selected);

    this.deleteUseSelectedUseCase(selectedItems, (deletedIds: any[]) => {
      // Only remove items from UI if they were successfully deleted
      this.filteredData = this.filteredData.filter(
        (item) => !deletedIds.includes(item.id),
      );
      this.masterSelected = false;

      // Refresh list or do any additional processing
      this.getUsecaseDataList();
    });
  }
  goToForm() {
    const fields = this.form.data['fields'];
    if (!fields || fields.length === 0) {
      alert('Add at least one input field to Add data');
      return;
    }
    this.checkAddOnRule();
  }
  getSanitizedHtml(html: any): SafeHtml {
    if (html && typeof html === 'object' && html.type === 'doc') {
      try {
        html = toHTML(html); // <-- ✅ Convert to real HTML
      } catch (err) {
        html = '';
      }
    }
    if (typeof html !== 'string') {
      html = String(html ?? '');
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  editors: { [key: string]: Editor } = {};
  activeEditorKey: string | null = null;

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  // Get or create editor instance
  getEditorInstance(rowId: number, fieldCode: string): Editor {
    const editorKey = `${rowId}_${fieldCode}`;

    if (!this.editors[editorKey]) {
      this.editors[editorKey] = new Editor({
        content: '',
        history: true,
        keyboardShortcuts: true,
      });
    }

    this.activeEditorKey = editorKey;
    return this.editors[editorKey];
  }

  startEditing(row: RowData, field: any) {
    if (this.form.data.readOnly === 'true') return;
    const nonEditableTypes = [
      'file',
      'doc',
      'location',
      'object',
      'map',
      'expression',
    ];
    if (nonEditableTypes.includes(field.type)) return;
    const data = this.usecaseAttributes.find(
      (item: any) => item.code === field.code,
    );
    if (data?.readOnly) {
      alert("This field is read-only. You can't modify it.");
      return;
    }

    row.editing = true;
    row.editingField = field.code;

    row._originalValue =
      typeof row[field.code] === 'object'
        ? JSON.parse(JSON.stringify(row[field.code]))
        : row[field.code];

    // Initialize editor content
    if (field.type === 'textarea' && field.enableEditor == 1) {
      const editor = this.getEditorInstance(row.id, field.code);
      editor.setContent(row[field.code] || '');
    }
  }

  // Handle editor content changes
  onEditorContentChange(rowId: number, fieldCode: string, content: string) {
    const editorKey = `${rowId}_${fieldCode}`;
    if (this.editors[editorKey]) {
      const row = this.filteredData.find((e) => e.id === rowId);
      if (row) {
        row[fieldCode] = content;
      }
    }
  }

  // Get current editor content as HTML
  getCurrentEditorContent(rowId: number, fieldCode: string): string {
    const editorKey = `${rowId}_${fieldCode}`;
    if (this.editors[editorKey]) {
      return this.editors[editorKey].view.dom.innerHTML;
    }
    return '';
  }

  stopEditing(row: RowData, field: any) {
    if (!row.editing) return;

    const fieldCode = row.editingField;
    if (!fieldCode) return;
    if (field.type === 'textarea') {
      if (field.enableEditor == 1) {
        row[fieldCode] = this.getCurrentEditorContent(row.id, fieldCode);
      } else {
        row[fieldCode] = this.removeHTMLTags(row[fieldCode]);
      }
    }

    // Prepare values for comparison
    const currentValue = row[fieldCode];
    const originalValue =
      field.enableEditor == 1
        ? row._originalValue
        : this.removeHTMLTags(row._originalValue);

    if (currentValue !== originalValue) {
      this.saveChanges(row, fieldCode, field);
    } else {
      this.cancelEditing(row);
    }
  }

  handleTextareaChange(rowId: number, fieldCode: string, value: string) {
    const row = this.filteredData.find((e) => e.id === rowId);
    if (row) {
      row[fieldCode] = value;
    }
  }
  // Cancel editing and revert changes
  cancelEditing(row: RowData) {
    if (row.editingField) {
      row[row.editingField] = row._originalValue;
    }
    row.editing = false;
    row.editingField = undefined;

    // Clean up active editor
    if (this.activeEditorKey) {
      this.destroyEditor(this.activeEditorKey);
      this.activeEditorKey = null;
    }
  }

  // Save to backend
  saveChanges(row: RowData, fieldCode: string, field: any) {
    const payload: any = {
      id: row.id,
      [fieldCode]:
        field.type === 'boolean' ? Number(row[fieldCode]) : row[fieldCode],
    };

    const url = this.urlRewrite(
      this.getAPIBaseUrl(this.form.data.code + '/saveForm'),
    );

    this.locator.http.post(url, payload, (res: any, error: boolean) => {
      if (error || !res?.success) {
        console.error('Save failed:', error || res?.message);

        // Initialize an error message string
        let errorMessage = 'Failed to save changes. Please try again.';

        // If there are server-side input errors, append them to the error message
        if (res?.result?.inputerror) {
          const inputErrors = res.result.inputerror;

          // Check if there's a 'key' error message and use it as a main error message
          if (inputErrors['key']) {
            errorMessage = inputErrors['key'];
          } else {
            const errorMessages = Object.values(inputErrors).join('\n');
            errorMessage += `${errorMessages}`;
          }
        }
        row[fieldCode] = row._originalValue;
        alert(errorMessage);
      } else {
        row._originalValue = row[fieldCode];
      }

      // Clean up
      if (this.activeEditorKey) {
        this.destroyEditor(this.activeEditorKey);
        this.activeEditorKey = null;
      }

      row.editing = false;
      row.editingField = undefined;
    });
  }

  destroyEditor(editorKey: string) {
    if (this.editors[editorKey]) {
      this.editors[editorKey].destroy();
      delete this.editors[editorKey];
    }
  }
  removeHTMLTags(html: string): string {
    if (!html) return '';
    const div = document.createElement('div'); // Temporary element banayenge
    div.innerHTML = html; // HTML inject karenge
    return div.textContent || div.innerText || ''; // Sirf text milega, no tags
  }

  override getUsecasePreloadData() {
    let _self = this;
    let url = _self.apiurl + '/preloadServer/' + _self.uiformId;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form['preload'] = res.result;
    });
  }

  getPreloadedLabel(at: any, selectedId: any): string {
    const options = this.form?.preload?.[at.primaryUsecase];
    if (!options) return '';

    const match = options.find((opt: any) => opt.id == selectedId);
    return match?._val || '';
  }
  openCodeInNewTab(type: string, value: string) {
    if (type === 'qr') {
      QRCode.toDataURL(value, { width: 200 }, (err, url) => {
        if (err) {
          console.error(err);
          return;
        }
        const win = window.open();
        win!.document.write(`
        <html>
          <head><title>QR Code</title></head>
          <body style="display: flex; align-items: center; justify-content: center; height: 100vh;">
            <img src="${url}" alt="QR Code">
          </body>
        </html>
      `);
      });
    } else if (type === 'bar') {
      const win = window.open();
      win!.document.write(`
      <html>
        <head><title>Barcode</title></head>
        <body style="display: flex; align-items: center; justify-content: center; height: 100vh;">
          <svg id="barcode"></svg>
          <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
          <script>
            JsBarcode("#barcode", "${value}", {format: "CODE128", width:2, height:100, displayValue: true});
          </script>
        </body>
      </html>
    `);
    }
  }
  checkAddOnRule() {
    let _self = this;
    const url = _self.urlRewrite(_self.getAPIBaseUrl('fetchRule'));
    _self.locator.http.post(
      url,
      { formId: _self.formId },
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error: ' + error);
          return;
        }
        const updatedFormID = res?.result?.data?.updatedFormID;
        if (updatedFormID && updatedFormID !== '') {
          _self.onEdit(updatedFormID);
        } else {
          _self.forward('/uiform/' + _self.form.data.id);
        }
      },
    );
  }
  getLocationObject(value: any): { lat: number; lng: number } | null {
    if (!value) return null;
    if (typeof value === 'string') {
      try {
        const cleaned = value
          .replace(/lat\s*:\s*/i, '"lat":')
          .replace(/lng\s*:\s*/i, '"lng":')
          .replace(/'/g, '"');
        return JSON.parse(cleaned);
      } catch (e) {
        console.error('Invalid location string:', value);
        return null;
      }
    }

    if (typeof value === 'object' && value.lat && value.lng) {
      return value;
    }
    return null;
  }

  getFilteredData(data: any[]) {
    return data;
  }

  onSearchReferenceValueChange1(e: any, value: any) {
    console.log(e);
    console.log(value);

    if (typeof value === 'object' && value !== null) {
      this.searchValues[e.code] =
        typeof value.id === 'number' ? Number(value.id) : String(value.id);
    } else if (e.type == 'list') {
      this.searchValues[e.code] = String(value);
    } else {
      this.searchValues[e.code] = value ?? undefined;
    }
  }
  compareFn = (item1: any, item2: any) => {
    return item1 == item2;
  };
  // Component TS
  filterFn = (term: string, item: any) => {
    if (!term) return true;
    term = term.toLowerCase();
    return item._val?.toLowerCase().includes(term);
  };

  getAppDocThumbnail(skey: number) {
    let _self = this;
    if (!skey) {
      if (_self.applogo) {
        skey = Number(_self.applogo);
      } else {
        skey = 0;
      }
    }
    let docAPI = this.locator.config.get('DOC_API');
    let url = docAPI + 'th/' + skey + '?t=' + this.imageTimestamp;
    return url;
  }

  /**
   * Get application doc
   * @param skey
   */
  getAppDoc(skey: number) {
    let _self = this;
    if (!skey) {
      if (_self.applogo) {
        skey = Number(_self.applogo);
      } else {
        skey = 0;
      }
    }
    return _self.getDoc(skey);
  }

  /* show full details on card view */

  selectedEntry: any = null;

  openViewModal(entry: any) {
    this.selectedEntry = entry;

    const modal = new bootstrap.Modal(
      document.getElementById('viewDetailsModal'),
    );
    modal.show();
  }

  //--------------------print option ---------------------//

  printModal(): void {
    console.log('hello world this is print method before return ...');
    const printContents = document.getElementById('printableArea')?.innerHTML;
    if (!printContents) return;

    console.log('hello world this is print method');

    const win = window.open('', '_blank', 'width=800,height=600');
    win?.document.write(`
    <html>
      <head>
        <title>${this.form.data['title']}</title>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #dee2e6; padding: 8px 12px; }
          th { background-color: #f8f9fa; }
          img { max-width: 80px; }
          @media print { body { padding: 0; } }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        <h5 style="margin-bottom:16px;">${this.form.data['title']}</h5>
        ${printContents}
      </body>
    </html>
  `);
    win?.document.close();
  }

  viewErrorDetails() {
    const modal = document.getElementById('uploadSummaryModal');
    const bsModal = (window as any).bootstrap.Modal.getInstance(modal);
    bsModal?.hide();

    this.router.navigate([
      '/upload-logs',
      this.usecaseId,
      this.uploadResult.uploadId,
    ]);
  }
  hidePassword = true;
}
